import { composeIO } from 'react-compose-io'
import { itemInadimplenciaIO } from './ItemInadimplencia.IO'
import { ItemInadimplenciaView } from './ItemInadimplencia.View'

export const ItemInadimplencia = composeIO(ItemInadimplenciaView, itemInadimplenciaIO)
